module.exports = __webpack_public_path__ + "static/media/FanSaves-Banner-Cheering.aee9009a.jpg";